<template>
  <app-card title="個人資訊">
    <v-card-text>
      <teacher-profile-info :profile="selfTeacherProfile" />
    </v-card-text>
  </app-card>
</template>

<script>
import {mapGetters} from 'vuex';
import TeacherProfileInfo from '../TeacherProfile/TeacherProfileInfo';

export default {
  components: {
    'teacher-profile-info': TeacherProfileInfo
  },

  data() {
    return {
    };
  },

  computed: {
    ...mapGetters('teacher', {
      selfTeacherProfile: 'selfTeacherProfile'
    })
  }
};
</script>

<style lang="stylus" scoped>

.info-list {
  width: 100%;
  padding-left: 0;
}

.info-item {
  display: flex;
  align-items: stretch;
  padding: 1rem;
  min-width: 320px;
  flex-grow: 1;

  &:hover {
    // background-color: $def-hover-color;
  }
}

.info-item__title {
  font-size: 1.1rem;
  margin-right: auto;
  color: rgba(0,0,0,0.8);
}

.info-item__content {
  max-width: 50%;
  text-align: right;
}

.info-item ~ .info-item {
  border-top: 1px solid rgba(0,0,0,0.12);
}

.info-item--self-intro {
  flex-direction: column;
}
</style>
